import { makeStyles } from "@material-ui/core";

export const css = makeStyles(() => ({
    modal: {
        textAlign: "center",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "0 30px",
    },
    header: {
        display: "flex",
        alignItems: "center",
        margin: "0 auto",
    },
    title: {
        fontWeight: "bold",
        margin: "24px auto",
    },
    closeButton: {
        zIndex: 1,
        position: "absolute",
        marginLeft: "52.5%",
        cursor: "pointer",
    },
}));
